import { k } from "../kaplay";
import { enemies } from "../data/enemies";

import { life } from "../components/life";
import { attack } from "../components/attack";

// Ajoute une fonction pour spawn un ennemi selon ses data
function addEnemy(enemyData, waveNumber) {
  let enemyX = 0;
  let enemyY = 0;

  if (Math.random() < 0.5) {
    enemyY = Math.random() < 0.5 ? -50 : k.height();
    enemyX = Math.random() * (k.width() + 50) - 50;
  }
  else {
    enemyX = Math.random() < 0.5 ? -50 : k.width();
    enemyY = Math.random() * (k.height() + 50) - 50;
  }

  // Progression logarithmique des stats
  const logFactor = Math.log2(waveNumber + 2);
  const stats = {
    ...enemyData.stats,
    maxLife: Math.floor(enemyData.stats.maxLife + logFactor / 2), // facteur ajustable
    speed: Math.floor(enemyData.stats.speed + logFactor * 1.5),   // facteur ajustable
    damage: Math.floor(enemyData.stats.damage + logFactor / 2),   // facteur ajustable
  };

  const newEnemy = k.add([
    "enemy",

    k.sprite(enemyData.sprite),
    k.pos(enemyX, enemyY),
    k.area({ scale: 0.6 }),
    k.anchor("center"),
    life({ maxLife: stats.maxLife }),
    k.move(k.center().angle(new k.Vec2(enemyX, enemyY)), stats.speed),
    k.offscreen({ destroy: true }),
    attack({ damage: stats.damage }),

    { speed: stats.speed, xp: enemyData.xp }
  ]);

  return newEnemy;
}

export function waveManager(){
  return {
    id: "waveManager",
    waveNumber: 0,
    spawning: true,
    add(){
      k.loop(15, () => {
        if (this.spawning){
          this.startWave();
        }
      });
    },
    async startWave() {
      const baseCount = 5;
      const factor = 2;
      const enemyCount = baseCount + this.waveNumber * factor;

      // Filtre les ennemis débloqués pour cette vague
      const availableEnemies = enemies.filter(e => e.wave <= this.waveNumber);

      for (let i = 0; i < enemyCount; i++) {
        // Choisit un type d'ennemi aléatoire parmi ceux disponibles
        const enemyData = availableEnemies[k.randi(0, availableEnemies.length)];
        const newEnemy = addEnemy(enemyData, this.waveNumber);
        if (!this.spawning){
          newEnemy.paused = true;
        }

        await k.wait(0.2)
      }
      this.waveNumber++;
    }
  }
}